import Component from '../colorz/Component';
import Splide from '@splidejs/splide';
import {Video} from '@splidejs/splide-extension-video';
import Device from '../colorz/utils/html/Device';
import {breakpointsApp} from '../colorz/configClrzApp';
import {forEach} from '@splidejs/splide/src/js/utils';

export default class SliderProductGallery extends Component {
	onInit(el) {
		this.el = el;
		this.elMainSlider = document.querySelector(
			'.js-slider-product-main-gallery',
		);
		this.elNav = document.querySelector('.js-slider-product-gallery-nav');
		this.btnVariants = document.querySelectorAll('[data-btn-variants]');

		this.isDesktop = Device.width > breakpointsApp.desktop;
		this.elZoomImgContent = this.el.querySelectorAll(
			'.js-product-zoom-img-content',
		);
		this.onPointerMove = this.onPointerMove.bind(this);
	}

	onReady() {
		var widthSlider = this.elNav.offsetWidth;
		var widthThumbnails = this.elNav.offsetWidth;
		var widthThumbnailsGap = widthThumbnails + 10; // gap de 10px
		var ratio = widthSlider / widthThumbnailsGap;

		this.isDesktop = Device.width > breakpointsApp.desktop;

		if (this.elNav.querySelectorAll('.splide__slide').length > 2) {
			var arrowsConf = true;
		} else {
			var arrowsConf = false;
		}

		var main = new Splide(this.elMainSlider, {
			type: 'slide',
			rewind: false,
			pagination: false,
			arrows: false,
			role: '',
			direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr',
			gap: '10px',
			breakpoints: {
				991: {
					pagination: true,
				},
			},
		});

		main.on('ready', () => {
			if (this.isDesktop) {
				this.elZoomImgContent.forEach((img) => {
					img.addEventListener(Device.pointermove, this.onPointerMove);
				});
			}
		});

		if (this.isDesktop) {
			// if product has more than 8 images, slider is display as loop
			this.lotOfMedia = parseInt(this.elNav.dataset.nbMedia) > 8;

			const optionsNav = {
				rewind: false,
				pagination: false,
				isNavigation: true,
				direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr',
				arrows: arrowsConf,
				width: this.lotOfMedia ? '90%' : 'auto',
				gap: 10,
				height: 70,
				fixedWidth: '5vw',
				fixedHeight: '5vw',
				perPage: 6,
				drag: !this.lotOfMedia,
				focus: 'center',
				slideFocus: true,
				role: '',
				breakpoints: {
					991: {
						destroy: true,
					},
				},
			};

			this.lotOfMedia && (optionsNav.type = 'loop');

			var thumbnails = new Splide(this.elNav, optionsNav);

			this.selectedVariant(main);

			main.sync(thumbnails);
			main.mount({Video});
			thumbnails.mount();

			if (window.location.href.indexOf('?variant=') > -1) {
				this.activeVariant(main);
			}
		} else {
			this.selectedVariant(main);
			main.mount({Video});

			if (window.location.href.indexOf('?variant=') > -1) {
				this.activeVariant(main);
			}
		}
	}

	/**
	 * selectedVariant
	 * on click on variant btn, slider go on selected slide
	 * @param {Object} main - Slider Splide
	 */
	selectedVariant(main) {
		this.btnVariants.forEach((element) => {
			//obtenir la valeur du dataset qui retourne une position/numero de slide {number}
			const el = element.dataset.variantFeaturedMediaPosition;

			element.addEventListener('click', (e) => {
				main.go(`>${el}`);
			});
		});
	}

	/**
	 * activeVariant
	 * on pae load, slider go on selected variant
	 * @param {Object} main - Slider Splide
	 */
	activeVariant(main) {
		const variantSelected = document.querySelector(
			'[data-btn-variants] .input-radio__variant:checked',
		);
		const featurePosition = variantSelected.closest('[data-btn-variants]')
			.dataset.variantFeaturedMediaPosition;

		main.options = {speed: 0};
		main.go(`>${featurePosition}`);
		main.options = {speed: 400};
	}

	onPointerMove(e) {
		const zoomer = e.currentTarget;
		this.offsetX = '';
		this.offsetY = '';
		this.x = '';
		this.y = '';

		if (e.offsetX) {
			this.offsetX = e.offsetX;
		}
		if (e.offsetY) {
			this.offsetY = e.offsetY;
		}

		this.x = (this.offsetX / zoomer.offsetWidth) * 100;
		this.y = (this.offsetY / zoomer.offsetHeight) * 100;
		zoomer.style.transform = `translate(-${this.x / 20}%, -${
			this.y / 20
		}%) scale(1.10)`;
	}
}
